import { MDBBtn, MDBIcon, MDBInput, MDBModalFooter, MDBSelect } from 'mdb-react-ui-kit'
import React, { forwardRef, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { deleteStorage, getMisc, purchaseStorage } from '../../../apiclients/streamsapi_bridge';
import { useForm } from 'react-hook-form';

const DeleteStorage = forwardRef((props, ref) => {
    const { t, i18n } = useTranslation();
    const [storageFlag, setstorageFlag] = useState(false);
    const [displayMessage, setdisplayMessage] = useState("");
    const [storageList, setStorageList] = useState([]);
    const [defaultValues, setdefaultValues] = useState({})
    const [quantities, setquantities] = useState([])
    const [billingGrps, setBillingGrps] = useState([]);
    const [billingId, setBillingId] = useState(-1);
    const { register, handleSubmit, formState: { errors, isDirty }, setValue, getValues, watch, reset, setError, clearErrors } = useForm({
        defaultValues: {
            storage_type: -1,
            quantity: -1,
            billing_group_id : -1

        }
    })

    async function fetchLocations() {
        console.log(sessionStorage.getItem("admin_session"));
        console.log("fid ::::: " + props.storageObj.fid);
        const response = await getMisc(
            JSON.parse(sessionStorage.getItem("admin_session")).siteid,
            { misc: ["delete_addon"], fid: parseInt(props.storageObj.fid) }
        );
        if (!response.json) {
            const message = `An error has occured: ${response.statusText}`;
            return;
        }
        const tdata = await response.json();
        if (!tdata) {
            window.alert(`info with id  not found`);
        }
        const locationList = tdata?.misc?.delete_addon?.locationDtls ?? [];
        console.log("purchase details :::::: " + JSON.stringify(tdata));
        const billingList = tdata?.misc?.delete_addon?.billingGrpsDtls;
        setBillingGrps(billingList);
        setstorageFlag(tdata?.misc?.delete_addon?.storageFlag ?? false);

    }


    useEffect(() => {
        if (props.storageObj && Object.keys(props.storageObj).length > 0) {
            fetchLocations();
        }
    }, [props.storageObj]);

    async function handleLocationChange(id) {
        try {
            console.log(sessionStorage.getItem("admin_session"));
            console.log("fid ::::: " + props.storageObj.fid);
            setBillingId(parseInt(id))
            const response = await getMisc(
                JSON.parse(sessionStorage.getItem("admin_session")).siteid,
                { misc: ["addon_storage_quantity"], billing_group_id: parseInt(id), fid: parseInt(props.storageObj.fid) }
            );
            if (!response.json) {
                const message = `An error has occured: ${response.statusText}`;
                return;
            }
            const tdata = await response.json();
            if (!tdata) {
                window.alert(`info with id  not found`);
            }
            let quantity = 0;
            if (!storageFlag) {
                console.log("quantity info :::::::: " + JSON.stringify(tdata));
                quantity = parseInt(tdata?.misc?.quantity) ?? 0;
                const options = Array.from({ length: quantity }, (_, index) => index + 1);
                console.log("Quantity ::::::::::: " + JSON.stringify(options));
                setquantities(options);

            } else {
                setStorageList(tdata?.misc?.storage_type ?? []);
            }

        } catch (error) {

        }
    }
    async function handleStorageChange(storageid) {
        try {
            console.log(sessionStorage.getItem("admin_session"));
            console.log("fid ::::: " + props.storageObj.fid);
            const response = await getMisc(
                JSON.parse(sessionStorage.getItem("admin_session")).siteid,
                { misc: ["addon_storage_quantity"], billing_group_id: parseInt(billingId), storage_type: parseInt(storageid), fid: parseInt(props.storageObj.fid) }
            );
            if (!response.json) {
                const message = `An error has occured: ${response.statusText}`;
                return;
            }
            const tdata = await response.json();
            if (!tdata) {
                window.alert(`info with id  not found`);
            }
            let quantity = 0;
            console.log("Storage info :::::::: " + JSON.stringify(tdata));

            quantity = parseInt(tdata?.misc?.quantity) ?? 0;
            const options = Array.from({ length: quantity }, (_, index) => index + 1);
            console.log("Quantity ::::::::::: " + JSON.stringify(options));
            setquantities(options);

        } catch (error) {

        }
    }

    const onSubmit = async (data) => {
        try {
            let flag = 0;
            if (storageFlag && data.storage_type == -1) {
                setError("storage_type", { message: "Please select a storage unit from the drop down" });
                flag = 1;
            }

            if (data.quantity && data.quantity == -1) {
                setError("quantity", { message: "Please select a quantity" });
                flag = 1;
            }

            if (data.billing_group_id == -1) {
                setError("billing_group_id", { message: "Please select a billing group" });
                flag = 1;
            }
            if (flag === 1) {
                return;
            }
            let update = {
                reqid: 68,
                fid: parseInt(props.storageObj.fid),
                siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
                quantity: parseInt(data.quantity),
                billing_group_id : parseInt(data.billing_group_id)
            }
            if (storageFlag) {
                update.storage_type = parseInt(data.storage_type);
            }

            console.log("Request JSON for purchase ::::: " + JSON.stringify(update));
            let saverep = await deleteStorage(update);
            console.log(saverep);
            let saverepeMsg = await saverep.json();
            console.log("response autopurchase ::::: " + JSON.stringify(saverepeMsg))
            //alert(saverepeMsg.status);
            if (saverepeMsg.status && saverepeMsg.status == "success") {
                props.setSuccessMessage(saverepeMsg.message);
                props.setrerender(true);
                props.onClose();




            } else {
                if (saverepeMsg.message?.errors) {
                    saverepeMsg.message.errors.forEach((err) => {

                        setError(err.param_name, {
                            type: "server",
                            message: err.message,
                        });

                    });
                }


            }

        } catch (error) {

        }
    }
    return (
        <>
            <div>
                <div className="d-flex mb-3 ">
                    <div className="fw-600 w-25">Billing Groups: </div>
                    <div className="d-flex w-200px flex-column">
                        <select className='form-select'

                            value={watch("billing_group_id")}

                            onChange={(e) => {
                                e.preventDefault();
                                if (e.target.value == -1) {
                                    setError("billing_group_id", { message: "select the billing group" })
                                    setValue("billing_group_id", e.target.value, { shouldDirty: true });
                                } else {
                                    clearErrors("billing_group_id");
                                    setValue("billing_group_id", e.target.value, { shouldDirty: true });
                                    handleLocationChange(e.target.value);
                                }
                            }}
                        >
                            <option key={-1} value={-1}>
                                --Select the Billing group--
                            </option>
                            {billingGrps &&
                                billingGrps.map((item) => (
                                    <>
                                        <option key={item.billing_group_id} value={item.billing_group_id}>
                                            {item.group_name}
                                        </option>
                                    </>
                                ))}
                        </select>
                        {errors.billing_group_id && (
                            <span className="text-danger">{errors.billing_group_id.message}</span>
                        )}
                    </div>
                </div>
                {storageFlag && (
                    <div className="d-flex  ">
                        <div className="fw-600 w-25">Storage: </div>
                        <div className="d-flex w-200px flex-column">
                            <select className='form-select'


                                value={watch("storage_type")}
                                onChange={(e) => {
                                    e.preventDefault();
                                    if (e.target.value == -1) {
                                        setError("storage_type", { message: "Please select a storage unit from the drop down" })
                                        setValue("storage_type", e.target.value, { shouldDirty: true });
                                    } else {
                                        clearErrors("storage_type");
                                        setValue("storage_type", e.target.value, { shouldDirty: true });
                                        handleStorageChange(e.target.value);
                                    }
                                }}
                            >
                                <option key={-1} value={-1}>
                                    -- select Storage --
                                </option>
                                {storageList && storageList.map((item, index) => {
                                    const key = Object.keys(item)[0]; // Extracting the key
                                    const value = item[key]; // Extracting the value
                                    return (
                                        <option key={index} value={key}>
                                            {value}
                                        </option>
                                    );
                                })}
                            </select>
                            {errors.storage_type && (
                                <span className="text-danger">{errors.storage_type.message}</span>
                            )}
                        </div>
                    </div>
                )}


                <div className="d-flex mt-3 ">
                    <div className="fw-600 w-25">Quantity: </div>
                    <div className="d-flex w-200px flex-column">
                        <select className='form-select'
                            value={watch("quantity")}
                            onChange={(e) => {
                                e.preventDefault();
                                console.log("fjrnfjrk "+e.target.value)
                                if (e.target.value == -1) {
                                    setError("quantity", { message: "Please select a quantity" })
                                    setValue("quantity", e.target.value, { shouldDirty: true });
                                } else {
                                    clearErrors("quantity");
                                    setValue("quantity", e.target.value, { shouldDirty: true });
                                }
                            }}
                        >
                            <option key={-1} value={-1}>
                                --Select the quantity--
                            </option>
                            {quantities && quantities.length > 0 && quantities.map(quant => (
                                <option key={quant} value={quant}>
                                    {quant}
                                </option>
                            ))}
                        </select>
                        {errors.quantity && (
                                <span className="text-danger">{errors.quantity.message}</span>
                            )}
                    </div>
                </div>
                <p className="m-0 text-small"><strong>Note: </strong>* Indicates that the Subtotal Group is already added to one or more Invoice Group</p>

                <div style={{ display: "none" }}>
                    <button ref={ref} onClick={(e) => { e.preventDefault(); handleSubmit(onSubmit)() }}>
                        {t("Delete")}</button>
                </div>

                {/* <MDBModalFooter>
                    <MDBBtn color='secondary' onClick={props.onClose}>
                        Cancel
                    </MDBBtn>
                    <MDBBtn onClick={(e) => {
                        e.preventDefault();
                        handleSubmit(onSubmit)();
                    }}>Delete</MDBBtn>
                </MDBModalFooter> */}

            </div>

        </>
    )
});

export default DeleteStorage;
